<template>
   <div class="parameters">
      <parameter-group
         v-for="(param,index) in params"
         :key="index"
         :title="param.title"
         :infos="param.infos"
      />
   </div>
</template>

<script>
import ParameterGroup from '../../../../organisms/Home/ParameterGroup';

export default {
   components: {
      ParameterGroup,
   },
   props: {
      params: {
         type: Array,
         required: true,
         validator: params => params.every(item => item.title && item.infos && Array.isArray(item.infos)),
      }
   },
}
</script>
